import React, { useEffect, useState } from "react";
import Select from "react-select";
import { OrderFilter } from "./components/orderFilter";
import TableLoader from "../../components/atoms/tableLoader";
import { OrderTable } from "./components/orderTable";
import CardHeader from "../../components/atoms/cardHeader";
import { DatePicker, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  GenerateManifestThunk,
  getInvoicesByRefsThunk,
  getSellerListingThunk,
  getStoresListingThunk,
  OrderRevenueThunk,
  OrderThunk,
} from "../../store/thunks/orderThunk";
import VendorStore from "../../components/atoms/vendorStores";
import { Pagination } from "../../components/atoms/pagination";
import { useLocation } from "react-router-dom";
import AllToolTip from "../../components/atoms/Tooltip/AllToolTips";
import dayjs from "dayjs";
import SelectOption from "../../components/atoms/formFields/selectOption";
import { resetManifest } from "../../store/slices/orderSlice";

const OrderList = ({ stores }) => {
  const dispatch = useDispatch();
  const {
    list: List,
    loading,
    pageInfo,
    count,
  } = useSelector((state) => state.orderListing);
  const { storeId } = useSelector((state) => state?.storeData || {});

  const { data: revenueData } = useSelector((state) => state.orderRevenue);
  const { data: manifestData } = useSelector((state) => state.generatemanifest);

  const { data: invoiceData } = useSelector(
    (state) => state.generatedInvoicesByRefs || {},
  );

  console.log("invoiceData", invoiceData);

  //SuperAdmin Start
  const [vendorName, setVendorName] = useState(null);
  const [storeName, setStoreName] = useState(null);

  const { data: getSellerListing } = useSelector(
    (state) => state.getSellerListing,
  );

  const { data: getStoresListing } = useSelector(
    (state) => state?.getStoresListing,
  );

  //SuperAdmin End

  const location = useLocation();
  const {
    Filters,
    PagiNation,
    selectedTab,
    ManifestCreation,
    shipmentSelection,
    InvoiceCreation,
    invoiceShipmentSelection
  } = location?.state || {};

  const startYear = 2023;
  const currentYear = new Date().getFullYear();

  const { user } = useSelector((state) => state.auth);
  const [selectedShipments, setSelectedShipments] = useState(
    shipmentSelection ? shipmentSelection : [],
  );

const [selectedInvoiceShipments, setSelectedInvoiceShipments] = useState(
  invoiceShipmentSelection ? invoiceShipmentSelection : [],
);
  const isSuperAdmin = user?.userType === "SUPER_VENDOR";

  const financialYears = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => {
      const year = startYear + i;
      return {
        label: `${year}-${String(year + 1).slice(-2)}`,
        value: `${year}-${String(year + 1).slice(-2)}`,
      };
    },
  );

  const [tabKey, setTabKey] = useState(selectedTab || "all");
  const [offset, setOffset] = useState(PagiNation ? PagiNation : 0);
  const [createManifest, setCreateManifest] = useState(
    ManifestCreation ? ManifestCreation : false,
  );

  const [createInvoice, setCreateInvoice] = useState(
    InvoiceCreation ? InvoiceCreation : false,
  );

  const [invoiceOrderRefIds, setInvoiceOrderRefIds] = useState([]);

  console.log(invoiceOrderRefIds, "invoiceOrderRefIds");

  console.log("createInvoicecreateInvoice out", createInvoice);

  const [orderIds, setOrderIds] = useState([]);

  const [submit, setSubmit] = useState({
    paginationFilter: {
      limit: 10,
      offset: PagiNation ? PagiNation : 0,
      order: "DESC",
    },
    //inventoryId: storeId,
    inventoryId: Filters?.inventoryId ? Filters?.inventoryId : storeId,

    orderId: Filters?.orderId ? Filters?.orderId : "",
    orderStage: Filters?.orderStage ? Filters?.orderStage : null,
    customerName: Filters?.customerName ? Filters?.customerName : "",
    customerId: Filters?.customerId ? Filters?.customerId : "",
    productName: Filters?.productName ? Filters?.productName : "",
    paymentMethod: Filters?.paymentMethod ? Filters?.paymentMethod : null,
    phoneNumber: Filters?.phoneNumber ? Filters?.phoneNumber : "",
    fromDate: Filters?.fromDate ? Filters?.fromDate : null,
    toDate: Filters?.toDate ? Filters?.toDate : null,
    deliveryWay: Filters?.deliveryWay ? Filters?.deliveryWay : null,
    isPreBookAble: Filters?.isPreBookAble ? Filters?.isPreBookAble : null,
    rtoOrder: Filters?.rtoOrder ? Filters?.rtoOrder : null,
    year: Filters?.year
      ? Filters?.year
      : `${currentYear}-${String(currentYear + 1).slice(-2)}`,
    settlementStatus: Filters?.settlementStatus
      ? Filters?.settlementStatus
      : null,
    vendorName: Filters?.vendorName ? Filters?.vendorName : null,
    storeName: Filters?.storeName ? Filters?.storeName : null,
    shipmentDate: Filters?.shipmentDate ? Filters?.shipmentDate : null,
  });

  useEffect(() => {
    setSubmit({
      paginationFilter: {
        limit: 10,
        offset: PagiNation ? PagiNation : 0,
        order: "DESC",
      },
      inventoryId: storeId,
      orderId: Filters?.orderId ? Filters?.orderId : "",
      orderStage: Filters?.orderStage ? Filters?.orderStage : null,
      customerName: Filters?.customerName ? Filters?.customerName : "",
      customerId: Filters?.customerId ? Filters?.customerId : "",
      productName: Filters?.productName ? Filters?.productName : "",
      paymentMethod: Filters?.paymentMethod ? Filters?.paymentMethod : null,
      phoneNumber: Filters?.phoneNumber ? Filters?.phoneNumber : "",
      fromDate: Filters?.fromDate ? Filters?.fromDate : null,
      toDate: Filters?.toDate ? Filters?.toDate : null,
      deliveryWay: Filters?.deliveryWay ? Filters?.deliveryWay : null,
      isPreBookAble: Filters?.isPreBookAble ? Filters?.isPreBookAble : null,
      rtoOrder: Filters?.rtoOrder ? Filters?.rtoOrder : null,
      year: Filters?.year
        ? Filters?.year
        : `${currentYear}-${String(currentYear + 1).slice(-2)}`,
      settlementStatus: Filters?.settlementStatus
        ? Filters?.settlementStatus
        : null,
      vendorName: Filters?.vendorName ? Filters?.vendorName : null,
      storeName: Filters?.storeName ? Filters?.storeName : null,
      shipmentDate: Filters?.shipmentDate ? Filters?.shipmentDate : null,
    });
  }, [Filters, selectedTab, PagiNation]);
  useEffect(() => {
    const { vendorName, storeName, ...apiPayload } = submit;

    dispatch(
      OrderThunk({
        orderRequestFilters: apiPayload,
      }),
    );

    dispatch(
      OrderRevenueThunk({
        orderRequestFilters: apiPayload,
      }),
    );
  }, [submit, tabKey, dispatch]);

useEffect(() => {
  setCreateManifest(ManifestCreation ?? false);
}, [ManifestCreation]);

useEffect(() => {
  setSelectedShipments(shipmentSelection ?? []);
}, [shipmentSelection]);

useEffect(() => {
  setCreateInvoice(InvoiceCreation ?? false);
}, [InvoiceCreation]);

useEffect(() => {
  setSelectedInvoiceShipments(invoiceShipmentSelection ?? []);
}, [invoiceShipmentSelection]);



  useEffect(() => {
    if (invoiceData?.invoiceUrl) {
      setSelectedInvoiceShipments([]);
      setInvoiceOrderRefIds([]);
      setCreateInvoice(false);

      window.open(invoiceData.invoiceUrl, "_blank", "noopener,noreferrer");
    }
  }, [invoiceData?.invoiceUrl]);

  // useEffect(() => {
  //   if (!storeId) return;
  //   if (Filters) {
  //     setSubmit((prev) => ({
  //       ...prev,
  //       paginationFilter: {
  //         ...prev.paginationFilter,
  //         limit: 2,
  //         offset: 0,
  //         order: "DESC",
  //       },
  //       inventoryId: storeId,
  //       orderId: Filters?.orderId ? Filters?.orderId : "",
  //       orderStage: Filters?.orderStage ? Filters?.orderStage : null,
  //       customerName: Filters?.customerName ? Filters?.customerName : "",
  //       customerId: Filters?.customerId ? Filters?.customerId : "",
  //       productName: Filters?.productName ? Filters?.productName : "",
  //       paymentMethod: Filters?.paymentMethod ? Filters?.paymentMethod : null,
  //       phoneNumber: Filters?.phoneNumber ? Filters?.phoneNumber : "",
  //       fromDate: Filters?.fromDate ? Filters?.fromDate : null,
  //       toDate: Filters?.toDate ? Filters?.toDate : null,
  //       year: Filters?.year
  //         ? Filters?.year
  //         : `${currentYear}-${String(currentYear + 1).slice(-2)}`,
  //       deliveryWay: Filters?.deliveryWay ? Filters?.deliveryWay : null,
  //       isPreBookAble: Filters?.isPreBookAble ? Filters?.isPreBookAble : null,
  //       rtoOrder: Filters?.rtoOrder ? Filters?.rtoOrder : null,
  //     }));
  //   } else {
  //     // Preserve existing filters on back-navigation; only reset pagination offset.
  //     setSubmit((prev) => ({
  //       ...prev,
  //       paginationFilter: {
  //         ...prev.paginationFilter,
  //         limit: 2,
  //         offset: 0,
  //         order: "DESC",
  //       },
  //       inventoryId: storeId,
  //     }));
  //   }
  // }, [storeId]);

  // Keep pagination offset in sync without resetting other filters

  useEffect(() => {
    if (!storeId && !Filters?.inventoryId) return;

    if (Filters) {
      setOffset(PagiNation ? PagiNation : 0);

      setSubmit((prev) => ({
        ...prev,
        paginationFilter: {
          ...prev.paginationFilter,
          limit: 10,
          offset: PagiNation ? PagiNation : 0,
          order: "DESC",
        },

        inventoryId: Filters?.inventoryId ? Filters?.inventoryId : storeId,

        orderId: Filters?.orderId ? Filters?.orderId : "",
        orderStage: Filters?.orderStage ? Filters?.orderStage : null,
        customerName: Filters?.customerName ? Filters?.customerName : "",
        customerId: Filters?.customerId ? Filters?.customerId : "",
        productName: Filters?.productName ? Filters?.productName : "",
        paymentMethod: Filters?.paymentMethod ? Filters?.paymentMethod : null,
        phoneNumber: Filters?.phoneNumber ? Filters?.phoneNumber : "",
        fromDate: Filters?.fromDate ? Filters?.fromDate : null,
        toDate: Filters?.toDate ? Filters?.toDate : null,
        year: Filters?.year
          ? Filters?.year
          : `${currentYear}-${String(currentYear + 1).slice(-2)}`,

        deliveryWay: Filters?.deliveryWay ? Filters?.deliveryWay : null,

        isPreBookAble: Filters?.isPreBookAble ? Filters?.isPreBookAble : null,

        rtoOrder: Filters?.rtoOrder ? Filters?.rtoOrder : null,

        vendorName: Filters?.vendorName || null,
        storeName: Filters?.storeName || null,
        shipmentDate: Filters?.shipmentDate || null,
      }));
    } else {
      setSubmit((prev) => ({
        ...prev,
        paginationFilter: {
          ...prev.paginationFilter,
          limit: 10,
          offset: 0,
          order: "DESC",
        },
        inventoryId: storeId,
      }));
    }
  }, [storeId, Filters, PagiNation]);

  const handlePageChange = (newOffset) => {
    setOffset(newOffset);

    setSubmit((prev) => ({
      ...prev,
      paginationFilter: {
        ...prev.paginationFilter,
        offset: newOffset,
      },
    }));
  };

  // // Auto-select all eligible shipments only once when manifest mode is first entered
  // useEffect(() => {
  //   if (!createManifest) return;

  //   const eligible = (List || []).filter(
  //     (item) =>
  //       item?.shippingPartner === "DELHIVERY_ONE" &&
  //       item?.orderStatus === "PACKED" &&
  //       (item?.shipRockedShipmentId ||
  //         item?.prozoAwbNumber ||
  //         item?.courierPartnerShipmentId),
  //   );

  //   if (eligible.length > 0) {
  //     setSelectedShipments(eligible);
  //   }
  //   // Only run when createManifest toggles to true, not on orderIds changes
  // }, [createManifest]);

  useEffect(() => {
    if (manifestData) {
      setSelectedShipments([]);
      setOrderIds([]);
      setCreateManifest(false);
      dispatch(resetManifest());

      manifestData &&
        window.open(manifestData, "_blank", "noopener,noreferrer");
    }
  }, [manifestData]);

  const orderTabs = [
    { key: "all", label: "All", countKey: "ALL", filters: {} },
    {
      key: "delivered",
      label: "Delivered",
      countKey: "DELIVERED",
      filters: { orderStage: "DELIVERED" },
    },
    {
      key: "processing",
      label: "Processing",
      countKey: "PROCESSING",
      filters: { orderStage: "PROCESSING" },
    },
    {
      key: "cancell",
      label: "Cancelled",
      countKey: "CANCELLED",
      filters: { orderStage: "CANCELLED" },
    },
    // {
    //   key: "pickup",
    //   label: "In-Store pickup",
    //   countKey: "INSTORE",
    //   filters: { deliveryWay: "PICK_UP_FROM_VENDOR" },
    // },
    {
      key: "shipped",
      label: "In-transit",
      countKey: "SHIPPED",
      filters: { orderStage: "SHIPPED" },
    },
    {
      key: "delivery",
      label: "Out for Delivery",
      countKey: "OUT_FOR_DELIVERY",
      filters: { orderStage: "OUT_FOR_DELIVERY" },
    },
    {
      key: "packed",
      label: "Packed",
      countKey: "PACKED",
      filters: { orderStage: "PACKED" },
    },
    {
      key: "prebooked",
      label: "Pre-Booked",
      countKey: "PREBOOKED",
      filters: { isPreBookAble: true },
    },
    {
      key: "RTO_INITIATED",
      label: "Rto Initiated",
      countKey: "RTO_INITIATED",
      filters: { rtoOrder: null, orderStage: "RTO_INITIATED" },
    },
    {
      key: "RTO_DELIVERED",
      label: "Rto Delivered",
      countKey: "RTO_DELIVERED",
      filters: { rtoOrder: null, orderStage: "RTO_DELIVERED" },
    },
    {
      key: "LOST",
      label: "Lost",
      countKey: "LOST",
      filters: { orderStage: "LOST" },
    },

    // {
    //   key: "prepaidorders",
    //   label: "Pre-Paid Orders",
    //   countKey: "PRE_PAID_ORDERS",
    //   filters: { paymentMethod: "INSTAMOJO" },
    // },
    // {
    //   key: "cashonDelivery",
    //   label: "COD",
    //   countKey: "COD_ORDERS",
    //   filters: { paymentMethod: "CASH_ON_DELIVERY" },
    // },
  ];

  useEffect(() => {
    if (selectedTab && selectedTab !== "all") {
      const selectedTabConfig = orderTabs.find(
        (tab) => tab.key === selectedTab,
      );
      if (selectedTabConfig) {
        setSubmit((prev) => ({
          ...prev,
          orderStage: null,
          deliveryWay: null,
          isPreBookAble: null,
          rtoOrder: null,
          // paymentMethod: null,
          ...selectedTabConfig.filters,
        }));
      }
    }
  }, [selectedTab]);

  useEffect(() => {
    dispatch(getSellerListingThunk());
  }, [dispatch]);

  // useEffect(() => {
  //   if (vendorName?.value) {
  //     dispatch(getStoresListingThunk(vendorName.value));
  //   }
  // }, [vendorName, dispatch]);

  useEffect(() => {
    if (submit?.vendorName?.value) {
      dispatch(getStoresListingThunk(submit.vendorName.value));
    }
  }, [submit?.vendorName?.value, dispatch]);

  return (
    <>
      <div className="content d-flex flex-column flex-column-fluid">
        <div className="container">
          <div className="align-items-center d-flex justify-content-between pb-6">
            <div className="flex">
              {/* For ALL Vendor Start */}
              {!isSuperAdmin && <VendorStore />}
              {/*For ALL Vendor End */}

              {/* For Super Admin Start */}
              {isSuperAdmin && (
                <>
                  <SelectOption
                    value={submit?.vendorName || null}
                    options={getSellerListing?.map((vendor) => ({
                      label: vendor?.name?.en,
                      value: vendor?.id,
                    }))}
                    onChange={(value) => {
                      if (value) {
                        setSubmit({
                          ...submit,
                          vendorName: value,
                          storeName: null,
                          inventoryId: null,
                          paginationFilter: {
                            ...submit.paginationFilter,
                            limit: 10,
                            offset: 0,
                            order: "DESC",
                          },
                        });

                        setOffset(0);

                        dispatch(getStoresListingThunk(value?.value));
                      } else {
                        setSubmit({
                          ...submit,
                          vendorName: null,
                          storeName: null,
                          inventoryId: null,
                        });

                        setOffset(0);
                      }
                    }}
                    extraClasses="w-235px mr-4"
                  />

                  <SelectOption
                    value={submit?.storeName || null}
                    options={getStoresListing?.map((store) => ({
                      label: store?.name?.en,
                      value: store?.id,
                    }))}
                    onChange={(value) => {
                      if (value) {
                        setSubmit({
                          ...submit,
                          storeName: value,
                          inventoryId: value?.value,
                          paginationFilter: {
                            ...submit.paginationFilter,
                            limit: 10,
                            offset: 0,
                            order: "DESC",
                          },
                        });

                        setOffset(0);
                      } else {
                        setSubmit({
                          ...submit,
                          storeName: null,
                          inventoryId: null,
                        });

                        setOffset(0);
                      }
                    }}
                    extraClasses="w-235px mr-4"
                  />
                </>
              )}

              {/*For Super Admin End */}

              <Select
                className="w-235px"
                placeholder="Select Financial Year"
                options={financialYears}
                value={
                  financialYears.find((item) => item.value === submit?.year) ||
                  null
                }
                onChange={(value) => {
                  if (value) {
                    setSubmit({
                      ...submit,
                      paginationFilter: {
                        ...submit.paginationFilter,
                        limit: 10,
                        offset: 0,
                        order: "DESC",
                      },
                      year: value?.value || value,
                    });
                    setOffset(0);
                  } else {
                    setSubmit({
                      ...submit,
                      year: null,
                    });
                    setOffset(0);
                  }
                }}
              />
            </div>

            <div className="">
              {isSuperAdmin && submit.inventoryId && (
                <>
                  <span
                    className={`btn btn-primary font-weight-bold letter-spacing btn-md collapsed mr-3 ${
                      createInvoice ? "disabled" : ""
                    }`}
                    onClick={() => {
                      // Do not allow Manifest while Invoice mode is active
                      if (createInvoice) return;

                      // Create Manifest
                      if (!createManifest) {
                        setCreateManifest(true);
                        setSelectedShipments([]);
                        setOrderIds([]);
                        setOffset(0);
                        setSubmit({
                          ...submit,
                          paginationFilter: {
                            ...submit.paginationFilter,
                            limit: 10,
                            offset: 0,
                          },
                          orderStage: "PACKED",
                        });

                        dispatch(
                          OrderThunk({
                            orderRequestFilters: {
                              paginationFilter: {
                                limit: 10,
                                offset: 0,
                                order: "DESC",
                              },
                              inventoryId: submit.inventoryId,
                              orderId: submit.orderId,
                              orderStage: "PACKED",
                              customerName: submit.customerName,
                              customerId: submit.customerId,
                              productName: submit.productName,
                              paymentMethod: submit.paymentMethod,
                              phoneNumber: submit.phoneNumber,
                              fromDate: submit.fromDate,
                              toDate: submit.toDate,
                              deliveryWay: submit.deliveryWay,
                              isPreBookAble: submit.isPreBookAble,
                              rtoOrder: submit.rtoOrder,
                              year: submit.year,
                              settlementStatus: submit.settlementStatus,
                              shipmentDate: submit.shipmentDate,
                            },
                          }),
                        );

                        return;
                      }

                      // Cancel Manifest
                      if (createManifest && selectedShipments.length === 0) {
                        setCreateManifest(false);
                        setSelectedShipments([]);
                        setOrderIds([]);
                        setOffset(0);
                        setSubmit({
                          ...submit,
                          paginationFilter: {
                            ...submit.paginationFilter,
                            limit: 10,
                            offset: 0,
                          },
                          orderStage: null,
                        });

                        dispatch(
                          OrderThunk({
                            orderRequestFilters: {
                              paginationFilter: {
                                limit: 10,
                                offset: 0,
                                order: "DESC",
                              },
                              inventoryId: submit.inventoryId,
                              orderId: submit.orderId,
                              orderStage: submit?.orderStage,
                              customerName: submit.customerName,
                              customerId: submit.customerId,
                              productName: submit.productName,
                              paymentMethod: submit.paymentMethod,
                              phoneNumber: submit.phoneNumber,
                              fromDate: submit.fromDate,
                              toDate: submit.toDate,
                              deliveryWay: submit.deliveryWay,
                              isPreBookAble: submit.isPreBookAble,
                              rtoOrder: submit.rtoOrder,
                              year: submit.year,
                              settlementStatus: submit.settlementStatus,
                              shipmentDate: submit.shipmentDate,
                            },
                          }),
                        );

                        return;
                      }

                      // Generate Manifest
                      if (selectedShipments.length > 0) {
                        dispatch(
                          GenerateManifestThunk({
                            orderId: orderIds,
                            storeId: submit.inventoryId,
                          }),
                        );
                      }
                    }}
                  >
                    {createManifest
                      ? selectedShipments?.length > 0
                        ? "Generate Manifest"
                        : "Cancel Manifest"
                      : "Create Manifest"}
                  </span>
                  <span
                    className={`btn btn-primary font-weight-bold letter-spacing btn-md collapsed mr-3 ${
                      createManifest ? "disabled" : ""
                    }`}
                    onClick={() => {
                      // Do not allow Invoice while Manifest mode is active
                      if (createManifest) return;

                      // Create Invoice
                      if (!createInvoice) {
                        setCreateInvoice(true);
                        setSelectedInvoiceShipments([]);
                        setInvoiceOrderRefIds([]);
                        setOffset(0);
                        setSubmit({
                          ...submit,
                          paginationFilter: {
                            ...submit.paginationFilter,
                            limit: 10,
                            offset: 0,
                          },
                          orderStage: "PACKED",
                        });

                        dispatch(
                          OrderThunk({
                            orderRequestFilters: {
                              paginationFilter: {
                                limit: 10,
                                offset: 0,
                                order: "DESC",
                              },
                              inventoryId: submit.inventoryId,
                              orderId: submit.orderId,
                              orderStage: "PACKED",
                              customerName: submit.customerName,
                              customerId: submit.customerId,
                              productName: submit.productName,
                              paymentMethod: submit.paymentMethod,
                              phoneNumber: submit.phoneNumber,
                              fromDate: submit.fromDate,
                              toDate: submit.toDate,
                              deliveryWay: submit.deliveryWay,
                              isPreBookAble: submit.isPreBookAble,
                              rtoOrder: submit.rtoOrder,
                              year: submit.year,
                              settlementStatus: submit.settlementStatus,
                              shipmentDate: submit.shipmentDate,
                            },
                          }),
                        );

                        return;
                      }

                      // Cancel Invoice
                      if (
                        createInvoice &&
                        selectedInvoiceShipments.length === 0
                      ) {
                        setCreateInvoice(false);
                        setSelectedInvoiceShipments([]);
                        setInvoiceOrderRefIds([]);
                        setOffset(0);
                        setSubmit({
                          ...submit,
                          paginationFilter: {
                            ...submit.paginationFilter,
                            limit: 10,
                            offset: 0,
                          },
                          orderStage: null,
                        });

                        dispatch(
                          OrderThunk({
                            orderRequestFilters: {
                              paginationFilter: {
                                limit: 10,
                                offset: 0,
                                order: "DESC",
                              },
                              inventoryId: submit.inventoryId,
                              orderId: submit.orderId,
                              orderStage: submit?.orderStage,
                              customerName: submit.customerName,
                              customerId: submit.customerId,
                              productName: submit.productName,
                              paymentMethod: submit.paymentMethod,
                              phoneNumber: submit.phoneNumber,
                              fromDate: submit.fromDate,
                              toDate: submit.toDate,
                              deliveryWay: submit.deliveryWay,
                              isPreBookAble: submit.isPreBookAble,
                              rtoOrder: submit.rtoOrder,
                              year: submit.year,
                              settlementStatus: submit.settlementStatus,
                              shipmentDate: submit.shipmentDate,
                            },
                          }),
                        );

                        return;
                      }

                      // Generate Invoice
                      if (selectedInvoiceShipments.length > 0) {
                        dispatch(
                          getInvoicesByRefsThunk({
                            orderRefIds: invoiceOrderRefIds,
                          }),
                        );
                      }
                    }}
                  >
                    {createInvoice
                      ? selectedInvoiceShipments?.length > 0
                        ? "Generate Invoice"
                        : "Cancel Invoice"
                      : "Create Invoice"}
                  </span>
                </>
              )}

              <span
                className="btn btn-primary font-weight-bold letter-spacing btn-md collapsed"
                data-target="#filter"
                data-toggle="collapse"
              >
                Filter
              </span>
            </div>
          </div>
        </div>

        {/*Filter Start*/}
        <OrderFilter
          submit={submit}
          setSubmit={setSubmit}
          setOffset={setOffset}
          selectedTab={selectedTab}
          setTabKey={setTabKey}
          
        />
        {/*Filter End*/}

        <div className="d-flex flex-column-fluid">
          <div className="container">
            <div className="d-flex flex-row">
              <div className="flex-row-fluid">
                <div className="card card-custom card-stretch">
                  <div className="card-header py-3 bg-gray-700">
                    <div className="align-items-center card-title d-flex justify-content-between m-0 w-100">
                      <h3 className="card-label font-weight-bolder text-white mr-0">
                        All Orders (
                        {revenueData?.ORDERS ? revenueData?.ORDERS : 0})
                      </h3>
                      <h3 className="card-label font-weight-bolder text-white right-0">
                        Revenue (
                        {revenueData?.REVENUE
                          ? revenueData?.REVENUE.toFixed(2)
                          : "0.00"}
                        )
                      </h3>
                    </div>
                  </div>

                  <div className="card-body p-4">
                    {isSuperAdmin && (
                      <>
                        <Tabs
                          activeKey={tabKey}
                          onChange={(key) => {
                            setTabKey(key);
                            setOffset(0);
                            const selectedTab = orderTabs.find(
                              (tab) => tab.key === key,
                            );
                            setSubmit((prev) => ({
                              ...prev,
                              paginationFilter: {
                                ...submit.paginationFilter,
                                limit: 10,
                                offset: 0,
                                order: "DESC",
                              },
                              orderStage: null,
                              deliveryWay: null,
                              isPreBookAble: null,
                              rtoOrder: null,
                              paymentMethod: submit?.paymentMethod
                                ? submit?.paymentMethod
                                : null,
                              ...selectedTab?.filters,
                            }));
                          }}
                          tabPosition="top"
                          className="custom-scroll-tabs"
                          items={orderTabs.map(
                            ({ key, label, countKey, filters }) => ({
                              key,
                              label: `${label} (${count?.[countKey] || 0})`,
                              children: loading ? (
                                <TableLoader />
                              ) : (
                                <OrderTable
                                  tabKey={key}
                                  list={List}
                                  offset={offset}
                                  submit={submit}
                                  isSuperAdmin={isSuperAdmin}
                                  createManifest={createManifest}
                                  createInvoice={createInvoice}
                                  setInvoiceOrderRefIds={setInvoiceOrderRefIds}
                                  invoiceOrderRefIds={invoiceOrderRefIds}
                                  setOrderIds={setOrderIds}
                                  orderIds={orderIds}
                                  selectedShipments={selectedShipments}
                                  setSelectedShipments={setSelectedShipments}
                                  selectedInvoiceShipments={
                                    selectedInvoiceShipments
                                  }
                                  setSelectedInvoiceShipments={
                                    setSelectedInvoiceShipments
                                  }
                                />
                              ),
                            }),
                          )}
                        />
                      </>
                    )}

                    {!isSuperAdmin && (
                      <>
                        <Tabs
                          activeKey={tabKey}
                          onChange={(key) => {
                            setTabKey(key);
                            setOffset(0);
                            const selectedTab = orderTabs.find(
                              (tab) => tab.key === key,
                            );
                            setSubmit((prev) => ({
                              ...prev,
                              paginationFilter: {
                                ...submit.paginationFilter,
                                limit: 10,
                                offset: 0,
                                order: "DESC",
                              },
                              orderStage: null,
                              deliveryWay: null,
                              isPreBookAble: null,
                              rtoOrder: null,
                              paymentMethod: submit?.paymentMethod
                                ? submit?.paymentMethod
                                : null,
                              ...selectedTab?.filters,
                            }));
                          }}
                          tabPosition="top"
                          className="custom-scroll-tabs"
                          items={orderTabs.map(
                            ({ key, label, countKey, filters }) => ({
                              key,
                              label: `${label} (${count?.[countKey] || 0})`,
                              children: loading ? (
                                <TableLoader />
                              ) : (
                                <OrderTable
                                  tabKey={key}
                                  list={List}
                                  offset={offset}
                                  submit={submit}
                                  isSuperAdmin={isSuperAdmin}
                                  createManifest={createManifest}
                                  setOrderIds={setOrderIds}
                                  orderIds={orderIds}
                                  selectedShipments={selectedShipments}
                                  setSelectedShipments={setSelectedShipments}
                                />
                              ),
                            }),
                          )}
                        />
                      </>
                    )}
                  </div>
                  <Pagination
                    pageInfo={pageInfo}
                    setOffset={handlePageChange}
                    offset={offset}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderList;
